export enum TransactionType {
  ADD = 'ADD',
  SPEND = 'SPEND',
  EXPIRE = 'EXPIRE',
  REMOVE = 'REMOVE',
  PORT = 'PORT',
  REFUND = 'REFUND',
  NEW_EQUIPMENT = 'NEW_EQUIPMENT',
}
